import { appClient } from 'src/config/apollo';
import { MeditationNode, ProgramNode } from 'src/generated/webapp_gql';

import { ToastNotificationsService } from 'src/shared/services/ToastNotificationsService';
import { GetMessageResourcesDocument } from '../documents/getMessageResourcesQuery.generated';

export type MessageResource = {
    programs: ProgramNode[];
    meditations: MeditationNode[];
};

export class MessageService {
    constructor(private toastNotificationsService: ToastNotificationsService) {
        this.toastNotificationsService = toastNotificationsService;
    }

    public async fetchResources(): Promise<MessageResource | null> {
        try {
            const { data } = await appClient.query({
                query: GetMessageResourcesDocument,
                fetchPolicy: 'network-only',
            });
            return data;
        } catch (error) {
            this.toastNotificationsService.renderErrorToast('Could not fetch resources.');

            return null;
        }
    }
}
